import salonUpdateActionType from 'actions/salon/salonUpdate.at';
import determineOpeningHours from 'bl/salon/determineOpeningHours.bl';
import { nowAsTimestamp } from 'utils/date/now.util';
import alwaysSame from 'utils/functions/nullary/alwaysSame.util';
import asObject from 'utils/objects/asObject.util';

const DEFAULT = Object.freeze({});

const reducePushedSalon = (state, action) => {
  const { action: pusherMethod, data: pusherBody, status: pusherStatus } = asObject(action.data);

  const updatedAt = nowAsTimestamp();

  if (pusherMethod !== 'UPDATE' || pusherStatus !== 200) {
    return { ...state };
  }

  // NOTE: with data.action === 'UPDATE', we can't know which property was changed, so we must update all
  // data.data.data is a result of packaging and re-packaging in message envelopes on both BE and FE side
  const { data: salon } = asObject(pusherBody);

  return {
    ...state,
    ...salon,
    openingHours: determineOpeningHours({ salon }),
    updatedAt,
  };
};

const MAP = Object.freeze({
  [salonUpdateActionType.push]: reducePushedSalon,
});

const pushedSalonReducer = (state, action) => (MAP[action && action.type] || alwaysSame)(state || { ...DEFAULT }, asObject(action));

// noinspection JSUnusedGlobalSymbols
export default pushedSalonReducer;
